export default "__VITE_ASSET__Cunq_KLU__";